const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/_minimal/live/$roomSlug/record.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
const liveRecordSearchSchema = z.object({
  recording_key: z.string().optional().catch(undefined)
});
export const Route = createFileRoute("/_minimal/live/$roomSlug/record")({
  validateSearch: liveRecordSearchSchema,
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});